/* eslint-disable i18next/no-literal-string */
import 'react-app-polyfill/ie11';
import 'element-scroll-polyfill';
import 'react-app-polyfill/stable';

import React from 'react';
import { createRoot } from 'react-dom/client';

import {GoogleMapsContextProvider} from '@ongov/location-react-components/src/components'
import { I18nextProvider } from 'react-i18next';

import i18n from './i18n';
import {getSearchBox} from "./utils/searchBoxLoad";

const language = document.body.parentElement?.getAttribute(`lang`) ?? `en`;
i18n.changeLanguage(language.match(/^fr-*/i) ? `fr` : `en`);
const {searchBoxIds, searchBoxes} = getSearchBox()

for (const id of searchBoxIds) {
  const container = document.getElementById(id);
  const root = createRoot(container!);
  root.render(
    <React.StrictMode>
      <I18nextProvider i18n={i18n}>
        <GoogleMapsContextProvider apiKey={process.env.REACT_APP_GATSBY_GOOGLE_API_KEY} mapId={process.env.REACT_APP_GATSBY_GOOGLE_MAP_ID}>
          {searchBoxes[id]}
        </GoogleMapsContextProvider>
      </I18nextProvider>
    </React.StrictMode>
  );
}
